import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouteObject,
  Routes,
} from "react-router-dom";
import { StaffHome } from "../pages/StaffHome/StaffHome";
import { BasePage } from "../pages/Staff/BasePage";
import { HomeOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { AppointmentController } from "../pages/Appointments/AppointmentController";
import { PatientProfile } from "../pages/Patients/Profile/PatientProfile";
import { DoctorScreenController } from "../pages/Doctor/DoctorScreenController";
import { useAppSelector } from "../redux/hooks";
import config from "../config/config";
import UnAuthorizedPage from "../components/AuthPages/UnAuthorizedPage";
import { ROLES } from "../config/roles";
import { checkUserHasRole } from "../utils/auth-utils";
import PageNotFound from "../components/AuthPages/PageNotFound";
import { PlusIcon } from "@radix-ui/react-icons";
import AdminPage from "../pages/Admin/AdminPage";

export type routeObjectType = {
  path: string;
  element: React.ReactNode;
  label: string;
  key: string;
  icon: React.ReactNode;
  topbar: boolean;
  roles: Array<string>;
};

export const allRoutes: routeObjectType[] = [
  {
    path: "/admin",
    element: <AdminPage />,
    label: "Admin",
    key: "admin",
    icon: <HomeOutlined />,
    topbar: true,
    roles: [ROLES.ADMIN_EDIT_ROLE],
  },
  {
    path: "/addpatient",
    element: <StaffHome />,
    label: "Add Patient",
    key: "addpatient",
    icon: <PlusIcon />,
    topbar: true,
    roles: [ROLES.ADD_PATIENT_VIEW_ROLE],
  },
  {
    path: "/appointments",
    element: <AppointmentController />,
    label: "Appointments",
    key: "appointments",
    icon: <HomeOutlined />,
    topbar: true,
    roles: [ROLES.APPOINTMENT_VIEW_ROLE],
  },

  {
    path: "/patient/profile/:patientID/appointment/:appointmentID",
    element: <PatientProfile />,
    label: "Patients",
    key: "patients",
    icon: <HomeOutlined />,
    topbar: false,
    roles: [ROLES.PATIENT_MEDICAL_VIEW],
  },
  {
    path: "/doctor-appointments",
    element: <DoctorScreenController />,
    label: "Doctor",
    key: "doctorScreen",
    icon: <UnorderedListOutlined />,
    topbar: true,
    roles: [ROLES.DOCTOR_APPOINTMENT_VIEW_ROLE],
  },
];

export const Router = () => {
  const actualRoles = useAppSelector((state) => state.auth.roles);
  return (
    <Routes>
      <Route>
        {routeConfig(allRoutes).map((routeElement) => {
          if (checkUserHasRole(routeElement.roles, actualRoles ?? [])) {
            return (
              <Route
                path={routeElement.path}
                element={routeElement.element}
                key={routeElement.path}
              />
            );
          } else {
            return (
              <Route
                path={routeElement.path}
                element={<UnAuthorizedPage />}
                key={routeElement.path}
              />
            );
          }
        })}
        <Route
          path="*"
          element={<PageNotFound />}
          // key={routeElement.path}
        />
      </Route>
    </Routes>
  );
};

function routeConfig(routeArray: routeObjectType[]) {
  const routeConfig = routeArray.map((route) => {
    return { path: route.path, element: route.element, roles: route.roles };
  });

  return routeConfig;
}
